import { LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const GlobalFeedbackCollector = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalFeedbackCollector" */ '../src/GlobalFeedbackCollector.tsx'
			)
		).GlobalFeedbackCollector,
});

export const LazyGlobalFeedbackCollector = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalFeedbackCollector" */ '../src/GlobalFeedbackCollector.tsx'
			)
		).GlobalFeedbackCollector,
});

export type { GlobalFeedbackCollectorComponentProps } from '../src/GlobalFeedbackCollector.tsx';
